var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Expand'),(_vm.news.content)?_c('div',{staticClass:"noticebox"},[_c('div',{staticClass:"container"},[_c('i',{staticClass:"ti-volume"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.news.content)}})])]):_vm._e(),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }